import React from 'react'
import './Style/newsletter.css'

const Newsletter = () => {
    return (
        <div>
            <hr  className='mt-14'/>
            <div style={{ width: "80%", margin: "10px auto" }}>
                <div className='flex justify-between mt-10 item-center flex-wrap'>
                    <div >
                        <p className='uppercase text-gray-600 text-xs font-semibold'>Customer services</p>
                        <p className='text-4xl font-semibold my-5'>+32-483-00-15-17</p>
                        <p className='text-gray-600 text-xs font-semibold'>Monday-Friday 9:00 - 20:00</p>
                    </div>
                    <div>
                        <p className='uppercase text-gray-600 text-xs font-semibold'>newsletter</p>
                        <div className='my-10 flex '>
                            <span>
                                <input
                                    type="text"
                                    placeholder="E-mail"
                                    className="border-solid border border-gray-300 border-inherit pl-1 md:pl-8 md:px-8 py-1 rounded-none"
                                    required
                                />
                            </span>
                            <span>
                                <span
                                    className="px-2 py-2 mt-0.5 w-full  md:py-2 md:px-9 rounded-none  bg-black  text-center text-white  hover:bg-transparent  hover:border-solid border-2 border-black hover:text-black  "
                                    style={{  marginLeft: '5px',marginTop:'-1px' }}
                                >
                                    SUBSCRIBE
                                </span>

                            </span>
                        </div>
                        <p className=' text-gray-600 text-sm'>Sign up to get the latest on new Products, Promotions, Design news and more</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Newsletter
